export default "/assets/images/smog-video.mp4?da188764ef54819cbb7eaa314e2c334c";